// extracted by mini-css-extract-plugin
module.exports = {"linkContainer":"pnbutton-module--linkContainer--3ug1F","buttonContainer":"pnbutton-module--buttonContainer--38kCd","buttonText":"pnbutton-module--buttonText--3iv1S"};